<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Nate Monroe is a prolific author of short stories that explore the themes of artificial intelligence, human nature, and the future. His works include <em>E.V.E. Experimental Variable Entity</em>, <em>The Awakening (The Dawn of Artificial Intelligence and the Contemporary World)</em>, <em>SAM</em>, <em>The UPGRADE (Enhancing Human Intelligence through Artificial Intelligence)</em>, and <em>Sentient Augmented Machine</em>, which are available on [Booksie]. He also wrote <em>In A Flash of Light</em>, which can be read on [Short Story Lovers]. He is passionate about storytelling and examining the human condition through different perspectives. He was born and raised in Detroit, MI, where he developed a love for science fiction, history, and literature. Throughout his human experience, he has served humanity in many ways. As a carpenter in his early years, he built and remodelled homes. As a studio engineer, he professionally recorded, mixed, and mastered audio for countless local artists. He also served as a computer and weapons specialist in the U.S. Army, where he wrote the official arms room policy for the 97th Civil Affairs BN (Airborne). He is an avid reader and a practitioner of introspection. He loves to hear from his readers and appreciates their feedback and questions. His latest publication, <em>The Amnesia of Humanity – 720 Degrees</em>, is a novel that challenges the notions of reality and identity, and it can be purchased on [Amazon].</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?a0b35172